import { render } from "./LightRegister.vue?vue&type=template&id=477cbfa7&scoped=true"
import script from "./LightRegister.vue?vue&type=script&lang=js"
export * from "./LightRegister.vue?vue&type=script&lang=js"

import "./LightRegister.vue?vue&type=style&index=0&id=477cbfa7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477cbfa7"]])

export default __exports__